import React, { useEffect, useRef, useState } from "react";
import { Music, VolumeX } from "lucide-react";

// Ambient background music: Jingle Bells (instrumental, CC0). Off by default; starts
// only on user click (browser autoplay policy) and remembers the preference.
export default function AmbientMusic() {
  const ref = useRef(null);
  const [on, setOn] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.volume = 0.35;
    if (on) el.play().catch(() => setOn(false));
    else el.pause();
  }, [on]);

  useEffect(() => {
    if (localStorage.getItem("mc_music") === "on") setOn(true);
  }, []);

  const toggle = () => {
    const next = !on;
    setOn(next);
    localStorage.setItem("mc_music", next ? "on" : "off");
  };

  return (
    <>
      <audio ref={ref} src="/jingle-bells.mp3" loop preload="none" />
      <button
        onClick={toggle}
        data-testid="ambient-music-toggle"
        aria-label="Toggle ambient music"
        title="Jingle Bells"
        className={`fixed bottom-20 right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full border shadow-lg backdrop-blur transition lg:bottom-6 ${on ? "border-xmas-gold bg-xmas-gold/20 text-xmas-gold" : "border-xmas-gold/30 bg-xmas-navycard/80 text-xmas-slate hover:text-xmas-snow"}`}
      >
        {on ? <Music className="h-5 w-5 animate-pulse" /> : <VolumeX className="h-5 w-5" />}
      </button>
    </>
  );
}
